import { api } from '@/api/client'
import type { CalendarPeriodResponse } from './types'

export async function fetchCalendarPeriod(year: number, month: number): Promise<CalendarPeriodResponse> {
  const period = `${String(month).padStart(2, '0')}.${year}`
  return api<CalendarPeriodResponse>(`/api/calendar/period/${encodeURIComponent(period)}`)
}
